// extracted by mini-css-extract-plugin
export default {"multimediaForm":"MultimediaForm_multimediaForm__eDjZl"};